import { ProviderIndex, providerIndexSsrLogic } from '@components/pages/provider';
import { ProviderDetails, providerDetailsSsrLogic } from '@components/pages/provider/details';
import { Default as DefaultLayout } from '@components/templates/layouts/Default';
import { prerenderPaths } from '@lib/graphql/helpers/prerenderPaths';
import { decodeOptions } from '@src/utils/urlHelpers';
import type { GetStaticPaths, GetStaticProps } from 'next';

function Providers({ data, slug }) {
  if (slug === 'index') {
    return <ProviderIndex />;
  }
  return <ProviderDetails data={data} />;
}

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: await prerenderPaths(['/provider/index']),
    fallback: 'blocking',
  };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const options = decodeOptions(params?.slug);

  if (options.slug === 'index') {
    return await providerIndexSsrLogic();
  }
  return await providerDetailsSsrLogic({ slug: options.slug });
};

Providers.PageLayout = DefaultLayout;

export default Providers;
